import { ListItem, ListItemText, Stack, Skeleton } from '@presov.sk/presov-ui-react';
import React from 'react';

const TransactionsListItemSkeleton: React.FC = () => {
  return (
    <ListItem alignItems='flex-start'>
      <ListItemText
        primary={
          <Skeleton variant='text' width={140} height={20} sx={{ mb: 0.5 }} />
        }
        secondary={
          <>
            <Skeleton variant='text' width='80%' height={16} sx={{ mb: 0.5 }} />
            <Skeleton variant='text' width={100} height={14} sx={{ mb: 0.5 }} />
            <Skeleton variant='text' width={80} height={14} />
          </>
        }
      />
      <Stack sx={{ alignItems: 'flex-end' }}>
        <Skeleton
          variant='rectangular'
          width={48}
          height={20}
          sx={{ mb: 0.5, borderRadius: 1 }}
        />
        <Skeleton variant='text' width={60} height={14} />
      </Stack>
    </ListItem>
  );
};

export default TransactionsListItemSkeleton;
